<template>
  <div class="short-answer">
    <div class="content-stem">
      <div>
        <span class="ques-num">{{ currentQuestion.showSerialNum }}</span>
        <span v-if="currentQuestion.additionalContent"
              v-html="currentQuestion.additionalContent"></span>
      </div>
      <div v-html="currentQuestion.content"/>
    </div>
    <!-- <strong>试问：指出报告中存在的问题并说明理由。</strong> -->
    <div class="sa-function clearfix"
         v-if="currentQuestion.quesTypeID === 4 || currentQuestion.quesTypeID === 5">
      <ul class="">
        <li>
          <el-tooltip effect="dark"
                      content="复制"
                      placement="top">
            <a href="javascript:void(0)"
               @click="copyFn">
              <img src="@/assets/images/formula/icon-copy.png"
                   alt="">
            </a>
          </el-tooltip>
        </li>
        <li>
          <el-tooltip effect="dark"
                      content="剪切"
                      placement="top">
            <a href="javascript:void(0)"
               @click="cutFn">
              <img src="@/assets/images/formula/icon-cut.png"
                   alt="">
            </a>
          </el-tooltip>
        </li>
        <li>
          <el-tooltip effect="dark"
                      content="粘贴"
                      placement="top">
            <a href="javascript:void(0)"
               @click="pasteFn">
              <img src="@/assets/images/formula/icon-paste.png"
                   alt="">
            </a>
          </el-tooltip>
        </li>
        <li>
          <el-tooltip effect="dark"
                      content="插入公式符号"
                      placement="top">
            <a href="javascript:void(0)"
               @click="openFormula(0)">
              <img src="@/assets/images/formula/icon-gs.png"
                   alt="">
            </a>
          </el-tooltip>
          <formula :visible.sync="visibleFm[0]"
                   @toggleFn="insertWrite"/>
        </li>
        <li>
          <el-tooltip effect="dark"
                      content="插入表格矩阵"
                      placement="top">
            <a href="javascript:void(0)"
               @click="openTable(0)">
              <img src="@/assets/images/formula/icon-jz.png"
                   alt="">
            </a>
          </el-tooltip>
          <matrix :visible.sync="visibleTable[0]"
                  @toggleTable="insertMatrix"
                  @delTable="deleteTable"/>
        </li>
      </ul>
    </div>
    <div class="sa-input"
         ref="saInput"
         v-if="currentQuestion.quesTypeID === 4 || currentQuestion.quesTypeID === 5">
      <div class="quesContent"
           ref="quesContent">
        <!--<strong>请在下方答题区域内作答。</strong><br/>-->
        <!--<div class="answerArea"-->
        <!--     ref="withoutChildAnswerArea"-->
        <!--     id="answerArea"-->
        <!--     contenteditable="true"-->
        <!--     @mouseup="mouseUpFn"-->
        <!--     v-html="currentQuestion.userAnswer">-->
        <!--</div>-->
        <div class="answerArea"
             ref="withoutChildAnswerArea"
             id="answerArea"
             contenteditable="true"
             @mouseup="mouseUpFn"
             v-html="checkHtml(currentQuestion.attAnswer) !== '' ? (checkHtml(currentQuestion.userAnswer) !== '' ? checkHtml(currentQuestion.userAnswer) : checkHtml(currentQuestion.attAnswer)) : checkHtml(currentQuestion.userAnswer)">
        </div>
        <!--普通卷-->
        <div v-if="$route.query.flag === 'ordinary'">
          <div class="is-show-answers"
               @click="toggleAnalyse"
               v-if="isShowAnswer"
               v-text="isAnswerShowNew === true ? '收起答案解析': '查看答案解析'">
          </div>
          <div class="answer-box"
               v-if="isAnswerShowNew">
            <strong class="answer-right">正确答案：</strong>
            <span v-html="currentQuestion.answer"
                  class="answer-right"></span><br/>
            <template
              v-if="currentQuestion.analysis!=='' && currentQuestion.analysis!==null">
              <strong class="answer-ananlysis">答案解析：</strong>
              <span v-html="currentQuestion.analysis"></span><br/>
            </template>
            <!--<span class="answer-assessment" v-if="isShowPointAssessment">【该题针对 <span
              class="answer-assessment-name" v-html="'“'+currentQuestion.pointNames+'”'"></span> 进行考核】</span>-->
            <template
              v-if="isShowVideoExplain && currentQuestion.vdeioAddr !== null && currentQuestion.vdeioAddr !== ''">
              <strong class="answer-ananlysis">视频解析：</strong>
              <a href="javascript:void(0)"
                 class="video-btn"
                 @click="videoExplain(currentQuestion.questionID,currentQuestion.pointList)">精讲视频</a>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="sa-input sa-input-simple"
         ref="saInput"
         v-else>
      <div class="quesContent quesContent-simple"
           ref="quesContent">
        <!-- 单选题、判断题 -->
        <template v-if="currentQuestion.quesTypeID === 1 || currentQuestion.quesTypeID === 3">
          <exam-single-choice :isShowProposal="isShowProposal"
                              :isShowAnswerQuestion="isShowAnswerQuestion"
                              :isShowAnswer.sync="isShowAnswer"
                              :isAnswerShow.sync="isAnswerShow"
                              :isShowQzSeat="isShowQzSeat"
                              :isShowCollect="isShowCollect"
                              :isShowPointAssessment="isShowPointAssessment"
                              :isShowVideoExplain="isShowVideoExplain"
                              :faqlUrl="faqlUrl"></exam-single-choice>
        </template>
        <!-- 多选题 -->
        <template v-if="currentQuestion.quesTypeID === 2">
          <exam-multiple-choice :isShowProposal="isShowProposal"
                                :isShowAnswerQuestion="isShowAnswerQuestion"
                                :isShowAnswer.sync="isShowAnswer"
                                :isAnswerShow.sync="isAnswerShow"
                                :isShowQzSeat="isShowQzSeat"
                                :isShowCollect="isShowCollect"
                                :isShowPointAssessment="isShowPointAssessment"
                                :isShowVideoExplain="isShowVideoExplain"
                                :faqlUrl="faqlUrl"></exam-multiple-choice>
        </template>
      </div>
    </div>

    <!--矩阵弹框-->
    <dialog-matrix :visible.sync="visibleMatrixTip"></dialog-matrix>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import Formula from '../formula'
import Matrix from '../matrix'
import editor from '@/mixins/editor'
import DialogMatrix from '@/components/exam/DialogMatrix'
import {ExamSingleChoice, ExamMultipleChoice} from '@components/exam'
import {removeHTMLTag} from "@/utils"
import {getPlayAuxiliaryUrl} from "@api";

export default {
  name: 'WithoutChildQuestion',
  components: {
    Formula,
    Matrix,
    ExamSingleChoice,
    ExamMultipleChoice,
    DialogMatrix,
  },
  computed: {
    ...mapGetters(['currentQuestionIndex', 'currentQuestion']),
  },
  props:{
    isShowAnswer: {
      //是否显示答案项
      type: Boolean,
      default: false
    },
    isShowVideoExplain: {
      //是否显示视频讲解
      type: Boolean,
      default: false
    },
  },

  mixins: [editor],
  data() {
    return {
      visibleTable: [false], // 矩阵显隐
      visibleMatrixTip: false, //矩阵提示弹框显隐
      visibleFm: [false], //  公式显隐
      visibleIME: false, //  输入法显隐
      smallIndex: 0,
      //容器对象
      rangeData: {
        //  鼠标选中数据
        start: 0,
        end: 0,
        text: '',
      },
      editorContainer: null,
      currentFormulaID: '', //  当前正在编辑的公式span的id
      blankSpan:
          '<span class="blankSpan">&nbsp;</span>',
      formulaHtml:
          '<span id="span_formula_{0}" class="isFormula"></span>',
      matrixHtml: '',
      timerMouseUP: null, // mouseUp计时器，光标问题临时解决方案
      isAnswerShowNew: this.isAnswerShow,
    }
  },
  mounted() {
  },
  methods: {
    toggleAnalyse() {
      this.isAnswerShowNew = !this.isAnswerShowNew
    },
    //视频讲解
    videoExplain(questionID, pointList) {
      let pointIDArr = [], pointIDStr = ''
      for (let i in pointList) {
        if (pointList[i] && pointList[i].pointID) {
          pointIDArr.push(pointList[i].pointID)
        }
      }
      pointIDStr = pointIDArr.join(',')
      let params = {
        questionId: String(questionID),
        pointList: pointIDStr
      }
      getPlayAuxiliaryUrl(params).then(res => {
        window.open(res.playUrl, '_blank')
      })
    },
    setCurrentSmallContent() {
      if (
          this.currentQuestion.quesTypeID === 4 ||
          this.currentQuestion.quesTypeID === 5
      ) {
        if (this.timerMouseUP) {
          clearTimeout(this.timerMouseUP)
        }
        let domInput = this.$refs['withoutChildAnswerArea']
        let attAnswer = this.currentQuestion.attAnswer
        // 避免attAnswer里有特殊字符如&times;等时造成将attAnswer与answer判为相等
        let el = document.createElement("div");
        el.innerHTML = attAnswer;
        attAnswer = el.innerHTML;

        let answer = (domInput.innerHTML === '<br/>' || domInput.innerHTML === '<br>' || domInput.innerHTML === 'null' || domInput.innerHTML === null) ? '' : domInput.innerHTML
        let isAnswer = 0
        // 主观题带有attAnswer判断是否答题  attAnswer 说明有表格题
        if (attAnswer) {
          if (removeHTMLTag(attAnswer) != removeHTMLTag(answer)) {
            isAnswer = 1
          } else {
            isAnswer = 0
          }
        } else {
          isAnswer = answer ? 1 : 0
        }
        this.$store.dispatch('setUserAns', answer)
        this.$store.dispatch('setIsAns', isAnswer)
      }
    },
    checkHtml(text) {
      return text === null || text === 'null' || text === '<br/>' || text === '<br>' ? '' : text
    },
  }
}
</script>
<style lang="scss" scoped>
$imgUrl: '~@/assets/images/formula/';
.short-answer {
  padding: 8px 16px;

  .content-stem {
    height: 100%;
    line-height: 1.6;
    color: #000000;
    width: 100%;
    margin-bottom: 10px;

    .ques-num {
      display: inline-block;
      padding: 0 5px;
      background-color: #447dff;
      color: #fff;
      font-style: normal;
      border-radius: 3px;
      min-width: 25px;
      text-align: center;
      margin-right: 10px;
    }
  }

  strong {
    display: inline-block;
    margin-top: 25px;
    margin-bottom: 8px;
  }

  .sa-function {
    background: #f0f0f0;
    padding: 3px 8px;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border: 1px solid #ddd;
    border-bottom: none;
    position: relative;

    ul {
      margin-left: 8px;
      overflow: hidden;
      height: 34px;

      li {
        float: left;
        display: inline-block;
        width: 30px;
        border: 1px solid transparent;
        text-align: center;
        line-height: 30px;
        margin-right: 8px;

        a {
          display: inline-block;
          width: 30px;

          &:hover {
            background-color: #ddd;
            border: 1px solid #ccc;
          }

          img {
            position: relative;
            top: 5px;
          }
        }
      }
    }
  }

  .sa-input {
    .answerArea {
      border: 1px solid #ddd;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      padding: 5px;
      outline: 0;
      overflow: auto;
      background-color: #fafafa;
      min-height: 250px;
      max-height: 500px;
      overflow-y: auto;
    }
  }
  .is-show-answers {
    width: 136px;
    height: 34px;
    line-height: 34px;
    color: #437eff;
    font-size: 16px;
    cursor: pointer;
    border-radius: 3px;
    border: 1px solid #1e74e1;
    text-align: center;
    margin-top: 15px;
  }

  .answer-box {
    margin-bottom: 5px;
    padding: 20px;
    font-size: 14px;
    color: #474747;
    line-height: 31px;
    margin-top: 10px;
    background: #f9f9fa;

    .answer-right {
      color: #56db9a;
      font-weight: bold;
    }

    .video-btn {
      color: #437eff;
    }
  }
}
</style>
